import React from 'react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service/translations/name-space.types';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { Icon } from '../Icon/Icon';
import { Button } from './Button';

export interface BackButtonProps {
	onClick: () => void;
}

export const BackButton = ({ onClick }: BackButtonProps) => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Global);
	return (
		<Button
			color="primary"
			type="link"
			onClick={onClick}
			size="s"
			aria-label={t('navigation.back')}
			className="button-plain"
			iconStart={
				<Icon
					name="chevron-left"
					type="components"
				/>
			}>
			{t('navigation.back')}
		</Button>
	);
};
